import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators, compose } from 'redux';

function mapStateToProps(state,props){
  return {
    isInvite:props.location.pathname.indexOf('invite') >= 0
  };
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({},dispatch);
}

export default compose(
  withRouter,
  connect(mapStateToProps,mapDispatchToProps)
);



// WEBPACK FOOTER //
// ./src/routes/OnboardingDemo/connect.js